import * as types from './mutation-types'

export default {
  [types.CONNECTION_CONFIG] (state, { jwt, id, unit, lang }) {
    state.jwt = jwt
    state.id = id
    state.unit = unit
    state.lang = lang
  },

  [types.SET_USER] (state, { user }) {
    state.user = user
  },

  [types.SET_USER_AVATAR] (state, avatar) {
    state.user = { ...state.user, avatar }
  },

  [types.SET_VEHICLE] (state, { vehicle }) {
    state.vehicle = vehicle
  },

  [types.SET_VIDEO] (state, { video }) {
    state.video = { ...video, current_time: 0, seek_time: 0 }
  },

  [types.VIDEO_TIME_UPDATE] (state, seconds) {
    state.video.current_time = seconds
  },

  [types.VIDEO_SEEK_TO] (state, seconds) {
    state.video.seek_time = seconds
  },

  [types.SET_TRACK] (state, { track }) {
    state.track = track
  },

  [types.SET_TRACK_POINTS] (state, { points }) {
    state.track = {
      ...state.track,
      points,
      current_idx: 0,
      interval: points[1].dur - points[0].dur
    }
  },

  [types.SET_TRACK_CURRENT_IDX] (state, { idx }) {
    state.track.current_idx = idx
  },

  [types.SET_TRACK_DISTANCES] (state, distances) {
    state.track = { ...state.track, distances }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js